import DataService from "./requestApi";

async function generateApiAction(func, ...args) {
  let responseObj = { data: null, error: null };

  try {
    const response = args.length ? await func(...args) : await func();

    if (response) {
      responseObj.data = response.data;
    }
    if (response?.data?.message === "invalid signature") {
      localStorage.removeItem("token");
      localStorage.removeItem("UserId");
      window.location.href = "/auth/login";
    }
  } catch (error) {
    responseObj.error = error.response?.data?.message || error.message;
  }

  return responseObj;
}

export const CallLogin = (data) => generateApiAction(DataService.Login, data);
export const CallCreateAdmin = (data) => generateApiAction(DataService.CreateAdmin, data);
export const CallFindAllUsersByParams = (data) => generateApiAction(DataService.FindAllUsersByParams, data);
export const CallAddStudentExcel = (data) => generateApiAction(DataService.AddStudentExcel, data);
export const CallFindAdminByVendorId = (data) => generateApiAction(DataService.FindAdminByVendorId, data);
export const CallGetAdminByAdminId = (data) => generateApiAction(DataService.GetAdminByAdminId, data);
export const CallUpdateUser = (id, data) => generateApiAction(DataService.UpdateUser, id, data);
export const CallUpdateStatus = (id, data) => generateApiAction(DataService.UpdateStatus, id, data);
export const CallGetUserByUserId = (id) => generateApiAction(DataService.GetUserByUserId, id);
export const CallUpdateFingerprint = (id, data) => generateApiAction(DataService.UpdateFingerprint, id, data);
export const CallGetReportByUserDataId = (id) => generateApiAction(DataService.GetReportByUserDataId, id);
export const CallAddSchoolAdmin = (data) => generateApiAction(DataService.AddSchoolAdmin, data);
export const CallDeleteSchoolAdmin = (data) => generateApiAction(DataService.DeleteSchoolAdmin, data);
export const CallFingerprintscanByVendorId = (data) => generateApiAction(DataService.FingerprintscanByVendorId, data);
export const CallGetReportPDF = (data) => generateApiAction(DataService.GetReportPDF, data);